import { css } from '@emotion/core';

const app_url = process.env.REACT_APP_URL;
const app_title = 'Encuentre el producto ideal en arquitectura y diseño | '+process.env.REACT_APP_TITLE;

const spinner_css = css`
    position: fixed;
    width: 100%;
    height: 100%;
    left:0;
    top:0;
    background: #fff;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;
const spinner_color = '#000000';
const spinner_size = 10;
const spinner_margin = '5px';


export default {
    spinner_css,
    spinner_color,
    spinner_size,
    spinner_margin,
    app_url,
    app_title,

}